import { ActiveModule } from "./active-module";
import { Logger } from "../../logger/logger";
import { LocalStorageManager } from "../storage/local-storage-manager";
import { UrlHelper } from "../html/url-helper";
import { DateHelper } from "../../helper/date-helper";

/**
* Helper class to get, update or delete an active module state
*/
export class ActiveModuleHelper {
	/**
	 * Standard namespace for active modules in sesstion storage
	 */
	public static readonly activeModulesKey = "nautilus_active_modules_";

	/**
	 * Standard time after module will be expired
	 */
	public static readonly moduleExpireAfter = 5 * 60 * 1000;

	/**
	 * Returns
	 */
	public static getActiveModuleNames = () => {
		let keys: string[] = [];
		let currentStorage = window.localStorage;
		for (let i = 0, len = currentStorage.length; i < len; ++i) {
			let currentKey = currentStorage.key(i);
			if (currentKey != null && currentKey.indexOf(ActiveModuleHelper.activeModulesKey) !== -1 && currentKey.indexOf(UrlHelper.getApplicationInstanceHash()) !== -1) {
				let moduleString = currentStorage.getItem(currentKey);
				if (moduleString && moduleString.length > 0) {
					let module: ActiveModule = JSON.parse(moduleString);
					if (!ActiveModuleHelper.expired(module.timestamp)) {
						keys.push(currentKey.replace(ActiveModuleHelper.activeModulesKey, "").replace(`_${UrlHelper.getApplicationInstanceHash()}`, ""));
					}
				}
			}
		}

		return keys;
	}

	/**
	 * Returns the module local storage keyname
	 */
	public static getModuleKey = (name: string) => {
		return ActiveModuleHelper.activeModulesKey + name;
	}

	public static activateKeepAlive(delay: number = 1000 * 60 * 1) {
		let ownkeepalive = $("body").data("ownkeepalive");
		if (ownkeepalive === true) {
			Logger.log("Shared keep alive disabled due to sites own implementation");
			return;
		}

		let nautilusWindowTitle = $("body").data("title");
		let nautilusWindowIsOpen = true;
		let updateModule = () => { ActiveModuleHelper.updateModule(nautilusWindowTitle); };

		try {
			setInterval(updateModule, delay);
			updateModule();

			window.onunload = () => {
				nautilusWindowIsOpen = false;
				ActiveModuleHelper.removeModule(nautilusWindowTitle);
			};

			window.addEventListener("storage", (e) => {
				if (nautilusWindowIsOpen
					&& e.key === ActiveModuleHelper.getModuleKey(nautilusWindowTitle)
					&& (e.newValue === "undefined" || e.newValue === null || e.newValue === "")) {
					ActiveModuleHelper.updateModule(nautilusWindowTitle, true);
				}
			}, false);
		} catch (err) {
			Logger.error("Could not track module state", err);
		}
	}

	/**
	 * Updates or insert an active module with the specified name
	 */
	public static updateModule = (name: string, onlyIfNotExists?: boolean): void => {
		if (name === "undefined" || name === null || name.length <= 0) {
			return;
		}
		let moduleKey = ActiveModuleHelper.getModuleKey(name);
		let activeModuleString = LocalStorageManager.getInstance().getItem(moduleKey);
		let activeModule = new ActiveModule(name);
		if (onlyIfNotExists && activeModuleString && activeModuleString.length > 0) {
			return;
		}

		ActiveModuleHelper.saveActiveModules(moduleKey, activeModule);
	}

	/**
	 * Removes an active module with the specified name
	 */
	public static removeModule = (name: string) => {
		if (name === "undefined" || name === null || name.length <= 0) {
			return;
		}
		LocalStorageManager.getInstance().removeItem(ActiveModuleHelper.getModuleKey(name));
	}

	/**
	 * Removes all active modules from local storage
	 */
	public static clearModules = () => {
		let keys = Object.keys(window.localStorage);
		let keysToDelete = keys.filter((value) => {
			return value.indexOf(ActiveModuleHelper.activeModulesKey) !== -1;
		});
		for (let value of keysToDelete) {
			LocalStorageManager.getInstance().removeItem(value);
		}
	}

	/**
	 * Saves an active module under the specified key into the local storage
	 */
	private static saveActiveModules = (key: string, activeModule: ActiveModule) => {
		LocalStorageManager.getInstance().setItem(key, JSON.stringify(activeModule));
	}

	/**
	 * Indicates if time is expired specified by the timestamp
	 */
	private static expired = (timestamp: number) => {
		return DateHelper.nowAsTicks() - timestamp > ActiveModuleHelper.moduleExpireAfter;
	}
}